import { StateSchema } from 'app/config/storeConfig/types';
import { CancelReservationModalSchema } from '../types';

export const getCancelReservationState = (state: StateSchema): CancelReservationModalSchema => state.cancelReservationModal;
